import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Tooltip,
  OverlayTrigger,
  Accordion,
} from "react-bootstrap";
import configData from "../../config.json";
import { toast } from "react-toastify";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Employeeattendance.css";
import moment from "moment";

export default class EmployeesAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      data: [],
      pData: [],
      employeelist: [],
      selectedEmployee: "",
      filteredLeave: [],
      groupedData: [],
      markedAttendanceDate: new Date(),
      Holidays: [],
      disabledDates: this.loadDisabledDatesFromStorage() || [],
      dataActual: [],
      attended: [],
      regularizedDates: [],
      leavedata: [],
      absentDates: [],
      leaveRequestDates: [],
      compOffDates: [],
      apiAbsentDays: 0,
      lopleaves: 0,
      //LeaveBalance: [],
      Lop: [],
      LeaveBalance: "",
      filteredData: null,
      currentMonthName: new Date().toLocaleDateString("en-GB", {
        month: "long",
      }),
      todayDay: new Date().toLocaleDateString("en-US", { weekday: "long" }),
      time: new Date().toLocaleTimeString(),
      currentDate: new Date().toLocaleDateString("en-GB"),
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      totalDaysInMonth: 0,
      totalWorkingDays: 0,
      presentDays: 0,
      absentDays: 0,
      halfDays: 0,
      lateDays: 0,
      holidays: 0,
      regularizedDays: 0,
      regularizedLeaveDates: [],
      totalLeavesTaken: 0,
      selectedYearMonth: null,
      calendarViewDate: new Date(),
      // seletctedDate: new Date(), // Generate last 12 months
      seletctedDate: "",
      months: [],
    };
  }
  normalizeDateList = (value) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }
    if (!value) {
      return [];
    }
    if (typeof value === "string") {
      return [value];
    }
    return [];
  };
  expandDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) {
      return [];
    }

    const dates = [];
    const start = new Date(fromDate);
    const end = new Date(toDate);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return [];
    }

    for (
      let current = new Date(start);
      current <= end;
      current.setDate(current.getDate() + 1)
    ) {
      dates.push(moment(current).format("YYYY-MM-DD"));
    }

    return dates;
  };
  getLast12Months() {
    let months = [];
    let currentDate = new Date();
    for (let i = 0; i < 36; i++) {
      let seletctedDate = "";
      let monthDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1,
      );
      // console.log(monthDate, "monthDate");
      months.push({
        value: monthDate.toLocaleDateString("en-CA", {
          year: "numeric",
          month: "2-digit",
        }), // Format: YYYY-MM
        label: monthDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        }),
      });
      // console.log(months);
      if (i === 0) {
        // console.log(monthDate, "monthDate");
        seletctedDate = months[i]["value"];
        // console.log(seletctedDate, "seletctedDate");
        this.setState({ seletctedDate: seletctedDate });
      }
    }
    this.setState({ months: months });
  }
  handleActiveStartDateChange = ({ activeStartDate }) => {
    this.setState({ calendarViewDate: activeStartDate });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  loadDisabledDatesFromStorage() {
    const disabledDates = JSON.parse(localStorage.getItem("disabledDates"));
    return disabledDates;
  }
  handleMonthYearChange = (event) => {
    const [year, month] = event.target.value.split("-").map(Number);
    this.setState({ currentYear: year, currentMonth: month }, () => {
      this.fetchDataForMonth(month, year);
    });
  };
  fetchDataForMonth = (month, year) => {
    this.HolidayslistfetchHandler(month, year);
    this.AttendencefetchHandler(this.state.selectedEmployee); // Pass the selected employee ID explicitly here
  };
  LeaverequestapprovalsfetchHandler = (eId) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("employees_Id", eId);
    fetch(configData.api_url + "C_Leaverequestapprovals/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const leaveDates = [];
          const compOffDates = [];
          const list = Array.isArray(data.list) ? data.list : [];

          const cancelledDatesByParent = {};
          list.forEach((record) => {
            if (
              record?.recordType === "cancellation" &&
              record?.cancellationDecision === "Approved" &&
              record?.parentLeaveId
            ) {
              let dates = [];
              try {
                dates = JSON.parse(record.cancellationDates) || [];
              } catch (e) {
                dates = [];
              }
              if (!cancelledDatesByParent[record.parentLeaveId]) {
                cancelledDatesByParent[record.parentLeaveId] = new Set();
              }
              dates.forEach((d) =>
                cancelledDatesByParent[record.parentLeaveId].add(d),
              );
            }
          });

          const approvedLeaves = list.filter(
            (leave) =>
              leave?.Decision === "Approved" &&
              leave?.recordType !== "cancellation",
          );
          approvedLeaves.forEach((leave) => {
            const fromDate = new Date(leave.FromDate);
            const toDate = new Date(leave.ToDate);
            const isCompensatory = leave.LeaveType === "Compensatory Leave";
            const cancelledDates =
              cancelledDatesByParent[leave.leaverequestapprovals_Id] ||
              new Set();
            for (
              let date = new Date(fromDate);
              date <= toDate;
              date.setDate(date.getDate() + 1)
            ) {
              const dateStr = `${date.getFullYear()}-${
                date.getMonth() + 1 < 10
                  ? "0" + (date.getMonth() + 1)
                  : date.getMonth() + 1
              }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}`;
              if (cancelledDates.has(dateStr)) continue;
              if (isCompensatory) {
                compOffDates.push(dateStr);
              } else {
                leaveDates.push(dateStr);
              }
            }
          });
          this.setState({ leaveRequestDates: leaveDates, compOffDates }, () => {
            this.calculateStats();
          });
        } else {
          this.setState({ leaveRequestDates: [], compOffDates: [] }, () => {
            this.calculateStats();
          });
        }
      });
  };
  handleEmployeeChange = (e) => {
    const selectedEmployee = e.target.value;
    this.setState({ selectedEmployee, selectedYearMonth: null }, () => {
      this.AttendencefetchHandler(selectedEmployee);
      this.LeaverequestapprovalsfetchHandler(selectedEmployee);
    });
  };
  handleAccordionToggle = (year, month) => {
    this.setState({ selectedYearMonth: `${year}-${month}` });
  };

  componentDidMount() {
    this.getLast12Months();
    this.HolidayslistfetchHandler();
    // this.getleaveBalance();
    // this.fetchDataForMonth(this.state.currentMonth, this.state.currentYear);
    this.EmployeesfetchHandler();
    this.updateTime();
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  updateTime = () => {
    setInterval(() => {
      this.setState({ time: new Date().toLocaleTimeString() });
    }, 1000);
  };
  handleClockInOut = () => {
    this.setState((prevState) => ({ clockedIn: !prevState.clockedIn }));
  };
  getleaveBalance = (eId) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("employees_Id", eId);
    fetch(configData.api_url + "C_Employees/retrive", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            LeaveBalance: data.detail.leaves,
            Usedleaves: data.detail.usedleaves,
            lopleaves: data.detail.lopleaves,
          });
        }
      });
  };
  // Fetch Holidays
  HolidayslistfetchHandler = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Holidayslist/list", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Holidays: data.list }, this.calculateStats);
        }
      });
  };

  // Fetch employee list
  EmployeesfetchHandler = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/listActive", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employeelist: data.list });
          this.calculateStats();
        }
      })
      .catch((error) => {
        this.showToast("Failed to fetch employees", "error");
      });
  };

  AttendencefetchHandler = (eId) => {
    const formData = new FormData();
    const { currentYear, currentMonth } = this.state;
    const monthParam = `${currentYear}-${String(currentMonth).padStart(2, "0")}`;
    formData.append("sId", this.state.sId);
    formData.append("employees_Id", eId); // Use eId of selected employee
    formData.append("month", monthParam);
    this.getleaveBalance(eId);

    fetch(configData.api_url + "C_Employees/getattendancebyId ", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const attendedList = this.normalizeDateList(data?.list?.attended);
          const pData = attendedList.map((pdates) => pdates.split(" ")[0]);
          const normalizedLeave = this.normalizeDateList(data?.list?.leave).map(
            (dateTime) => String(dateTime).split(" ")[0],
          );
          const normalizedRegularize = this.normalizeDateList(
            data?.list?.regularize,
          ).map((dateTime) => dateTime.split(" ")[0]);
          const absentDates = this.expandDateRange(
            data?.list?.absent?.FromDate,
            data?.list?.absent?.ToDate,
          );
          this.setState(
            {
              data: attendedList,
              pData,
              dataActual: attendedList,
              leavedata: normalizedLeave,
              regularizedDates: normalizedRegularize,
              absentDates,
            },
            () => {
              this.calculateStats();
              this.groupDataByYearAndMonth();
            },
          );
        }
      });
  };
  getEmployeeAttendenceReport = (e) => {
    e.preventDefault();
    // console.log(this.state.seletctedDate);
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("month", this.state.seletctedDate); // Use eId of selected employee
    fetch(configData.api_url + "C_Employees/getattendencereportByMonth", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.downloadPdf(data.pdfPath);
        }
      });
  };
  downloadPdf = (policyPdf) => {
    const pdfUrl = configData.api_url + policyPdf;
    window.open(pdfUrl, "_blank");
  };
  groupDataByYearAndMonth = () => {
    const { data } = this.state;
    let groupedData = {};
    data.forEach((attendance) => {
      const date = new Date(attendance);
      const year = date.getFullYear();
      const month = date.getMonth(); // 0 - 11 for months
      if (!groupedData[year]) {
        groupedData[year] = [];
      }
      if (!groupedData[year][month]) {
        groupedData[year][month] = [];
      }
      groupedData[year][month].push(attendance);
    });
    // Convert the groupedData object into an array of year-month groups
    const formattedGroupedData = Object.keys(groupedData).map((year) => ({
      year,
      months: groupedData[year].map((monthData, monthIndex) => ({
        month: monthIndex + 1, // Display month as 1-12
        data: monthData,
      })),
    }));

    this.setState({ groupedData: formattedGroupedData });
  };
  calculateStats = () => {
    const {
      pData,
      dataActual,
      leavedata,
      absentDates,
      regularizedDates,
      Holidays,
      currentMonth,
      currentYear,
    } = this.state;
    const daysInMonth = new Date(currentYear, currentMonth, 0).getDate();
    let presentDays = 0;
    let absentDays = 0;
    let holidays = 0;
    let totalWorkingDays = 0;
    let regularizedDays = 0;
    let regularizedLeaveDates = [];
    let approvedLeaveDays = 0;
    let lateDays = 0;
    let totalLeavesTaken = 0;
    let apiAbsentDays = 0;
    // Debug arrays to track which days are counted in each category
    let presentDaysArray = [];
    let regularizedDaysArray = [];
    let approvedLeaveDaysArray = [];
    let workingDaysArray = [];

    const totalDaysInMonth = daysInMonth;

    // Calculate holidays in current month
    Holidays.forEach((holiday) => {
      const holidayDate = new Date(holiday.Date);
      if (
        holidayDate.getMonth() + 1 === currentMonth &&
        holidayDate.getFullYear() === currentYear
      ) {
        holidays++;
      }
    });

    // Calculate total working days
    for (let i = 1; i <= daysInMonth; i++) {
      const date = moment(
        `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(
          i,
        ).padStart(2, "0")}`,
        "YYYY-MM-DD",
      ).format("YYYY-MM-DD");

      const day = new Date(date).getDay();
      const isHoliday = Holidays.some((holiday) => holiday.Date === date);
      const isWeekend = day === 0;

      if (!isHoliday && !isWeekend) {
        totalWorkingDays++;
      }
    }

    // Leave count comes only from the attendance API's `leave` array
    totalLeavesTaken = [...new Set(leavedata)].filter((leaveDate) => {
      if (!leaveDate) return false;
      const leaveMoment = moment(leaveDate, "YYYY-MM-DD", true);
      return (
        leaveMoment.isValid() &&
        leaveMoment.month() + 1 === currentMonth &&
        leaveMoment.year() === currentYear
      );
    }).length;

    apiAbsentDays = absentDates.filter((absentDate) => {
      if (!absentDate) return false;
      const absentMoment = moment(absentDate, "YYYY-MM-DD", true);
      return (
        absentMoment.isValid() &&
        absentMoment.month() + 1 === currentMonth &&
        absentMoment.year() === currentYear
      );
    }).length;

    // Calculate not marked days only up to today
    const today = moment().format("YYYY-MM-DD");

    // First determine all working days until today
    let workingDaysUntilToday = 0;
    for (let i = 1; i <= daysInMonth; i++) {
      const date = moment(
        `${currentYear}-${String(currentMonth).padStart(2, "0")}-${String(
          i,
        ).padStart(2, "0")}`,
        "YYYY-MM-DD",
      ).format("YYYY-MM-DD");

      if (date > today) break; // Stop counting after today

      const day = new Date(date).getDay();
      const isHoliday = Holidays.some((holiday) => holiday.Date === date);
      const isWeekend = day === 0;

      if (!isHoliday && !isWeekend) {
        workingDaysUntilToday++;
        workingDaysArray.push(date); // Track for debugging
      }
    }

    // Process each working day to categorize attendance
    for (let i = 0; i < workingDaysArray.length; i++) {
      const date = workingDaysArray[i];
      let dayStatus = "absent"; // Default status

      const isPresent = pData.some((attendanceDate) => {
        const attendanceOnlyDate = attendanceDate.split(" ")[0];
        return attendanceOnlyDate === date;
      });

      // Check for attendance by comparing only the date part
      const isLate = dataActual.some((attendanceDate) => {
        let isLateReturn = false;
        const attendanceOnlyDate = attendanceDate.split(" ")[0];
        if (attendanceOnlyDate === date) {
          // console.log(attendanceOnlyDate,"actualDate");
          const actualDate = new Date(`${attendanceOnlyDate}T10:15:00`);
          const givenDateTime = new Date(attendanceDate);
          const isLateDate = givenDateTime.getTime();
          const isactualdateDate = actualDate.getTime();
          // console.log(attendanceDate,"attendanceDate");
          if (isLateDate > isactualdateDate) {
            // console.log(attendanceDate,"attendanceDate1");
            isLateReturn = true;
          }
        }
        return isLateReturn;
      });

      if (isPresent) {
        // console.log(date);
        presentDays++;
        if (isLate) {
          lateDays++;
        }
        presentDaysArray.push(date); // Track for debugging
        dayStatus = "present";
      }

      // Only check for leave if not present
      if (dayStatus === "absent") {
        const isRegularizedLeave = regularizedDates.includes(date);

        if (isRegularizedLeave) {
          regularizedDays++;
          regularizedLeaveDates.push(date);
          regularizedDaysArray.push(date); // Track for debugging
          dayStatus = "regularized";
        }
      }

      // Only check for approved leave if not present and not regularized
      if (dayStatus === "absent") {
        const isApprovedLeave = leavedata.includes(date);
        if (isApprovedLeave) {
          approvedLeaveDays++;
          approvedLeaveDaysArray.push(date); // Track for debugging
          dayStatus = "approved leave";
        }
      }
    }

    // Calculate absent days correctly - ensure it's never negative
    absentDays = Math.max(
      0,
      workingDaysUntilToday -
        (presentDays + regularizedDays + approvedLeaveDays),
    );

    // Log debug information

    this.setState({
      totalWorkingDays,
      presentDays,
      absentDays,
      holidays,
      totalDaysInMonth,
      regularizedDays,
      regularizedLeaveDates,
      totalLeavesTaken,
      apiAbsentDays,
      lateDays,
      // Add these for debugging if needed
      workingDaysCount: workingDaysUntilToday,
      presentDaysCount: presentDays,
      regularizedDaysCount: regularizedDays,
      approvedLeaveDaysCount: approvedLeaveDays,
    });
  };
  isDateDisabled = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    if (dayOfWeek === 0 || holiday) {
      return true;
    }
    return false;
  };
  // Handle date change in calendar
  handleDateChange = (date) => {
    this.setState({ markedAttendanceDate: date });
  };
  handleselectDateChange = (event) => {
    //this.setState({ seletctedDate: event.target.value });
    const selectedDate = event.target.value; // "2025-04"
    const [year, month] = selectedDate.split("-").map(Number);
    const newCalendarViewDate = new Date(year, month - 1, 1);
    this.setState(
      {
        seletctedDate: selectedDate,
        currentYear: year,
        currentMonth: month,
        calendarViewDate: newCalendarViewDate,
      },
      () => {
        this.fetchDataForMonth(month, year);
      },
    );
  };
  // Format date in YYYY-MM-DD format
  formatDate = (dateString) => {
    if (!dateString) return "Invalid Date";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";

    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };
  isDateLate = (dateString) => {
    return this.state.dataActual.some((attendanceDate) => {
      if (!attendanceDate) return false;

      const attendanceOnlyDate = attendanceDate.split(" ")[0];
      if (attendanceOnlyDate === dateString) {
        const actualDate = new Date(`${attendanceOnlyDate}T10:15:00`);
        const givenDateTime = new Date(attendanceDate);
        return givenDateTime.getTime() > actualDate.getTime();
      }

      return false;
    });
  };

  isWorkDay = (year, month, day) => {
    const weekDay = new Date(year, month, day).getDay();
    return weekDay === 2 || weekDay === 3;
  };
  tileClassName = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are zero-based
    const day = date.getDate();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    const leaveDates = this.state.leavedata || [];
    const isRegularized = this.state.regularizedDates.includes(dateString);
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    const isLeave = leaveDates.includes(dateString);
    const isAbsent = this.state.absentDates.includes(dateString);
    const isCompOff = this.state.compOffDates?.includes(dateString);
    const isLeaveRequest = this.state.leaveRequestDates?.includes(dateString);
    // Check if the current date is in the attendance list
    const isAttendance = this.state.pData.find(
      (attendance) => attendance === dateString,
    );
    // Check if the current date is a holiday
    const isHoliday = holiday !== undefined;
    const isSunday = date.getDay() === 0;
    const isWorkingDay = !isHoliday && !isSunday;
    const isUnmarkedWorkingDay =
      isWorkingDay &&
      !isAttendance &&
      !isLeave &&
      !isRegularized &&
      !isLeaveRequest &&
      !isCompOff;

    if (isLeave) {
      return "leave-date";
    } else if (isRegularized) {
      return "regularized";
    } else if (isHoliday) {
      return "holiday";
    } else if (isAttendance && this.isDateLate(dateString)) {
      return "late-attendance";
    } else if (isAttendance) {
      return "attendance-date";
    } else if (isCompOff) {
      return "compoff-date";
    } else if (isLeaveRequest) {
      return "leave-request";
    } else if (isAbsent) {
      return "absent-date";
    } else if (isUnmarkedWorkingDay) {
      return "unmarked-working-day";
    } else {
      return null;
    }
  };
  render() {
    const { employeelist, groupedData } = this.state;
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 10);
    return (
      <Container className="employee-attendance-page">
        <Row>
          <div className="col-md-3">
            <div className="widget_BG widget_BG_grid">
              {/* <h3 className="">Attendance {uName}</h3> */}

              <h3 className="">Employees List</h3>
            </div>
          </div>
          <div className="col-md-3 text-center">
            <div className="widget_BG">
              <Form.Select
                onChange={this.handleEmployeeChange}
                aria-label="Select Employee"
                className="form-control"
                id="employee"
                name="employee"
              >
                <option value="">Select Employee</option>
                {window
                  .sortByKey(employeelist, "fName")
                  .map((employee, index) => (
                    <option key={index} value={employee.employees_Id}>
                      {employee.fName} {employee.lName} - {employee.eId}
                    </option>
                  ))}
              </Form.Select>
            </div>
          </div>
          <div className="col-md-6 ">
            <div className="widget_BG widget_BG_grid">
              <div className="row">
                <div className="col-md-6">
                  <select
                    value={this.state.seletctedDate}
                    onChange={this.handleselectDateChange}
                    className="form-control form-select"
                  >
                    {this.state.months.map((month) => (
                      <option key={month.value} value={month.value}>
                        {month.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 text-end">
                  <button
                    type="button"
                    className="btn btn-primary border_radius"
                    onClick={this.getEmployeeAttendenceReport}
                  >
                    Get Monthly Report
                  </button>
                </div>
              </div>
              <Col lg="6" className="selectedMonth"></Col>
              {/* <h4>
                {this.state.currentDate} {this.state.time} {this.state.todayDay}
              </h4> */}
            </div>
          </div>
        </Row>
        <div className="mt-2">
          <Row>
            <Col lg="4" md="4">
              {this.state.selectedEmployee && (
                <Calendar
                  onChange={this.handleDateChange}
                  value={this.state.markedAttendanceDate}
                  activeStartDate={this.state.calendarViewDate}
                  onActiveStartDateChange={this.handleActiveStartDateChange}
                  tileClassName={this.tileClassName}
                  tileDisabled={this.isDateDisabled}
                  tileContent={({ date, view }) => {
                    // Display holiday purpose on hover for month view
                    if (view === "month") {
                      const year = date.getFullYear();
                      const month = date.getMonth() + 1; // Months are zero-based
                      const day = date.getDate();
                      const dateString = `${year}-${
                        month < 10 ? "0" + month : month
                      }-${day < 10 ? "0" + day : day}`;
                      const isAttendance =
                        this.state.pData.includes(dateString);
                      const isLateAttendance = isAttendance
                        ? this.isDateLate(dateString)
                        : false;
                      const isRegularized =
                        this.state.regularizedDates.includes(dateString);
                      const isLeave = this.state.leavedata.includes(dateString);
                      const isAbsent =
                        this.state.absentDates.includes(dateString);
                      const isCompOff =
                        this.state.compOffDates?.includes(dateString);
                      const isLeaveRequest =
                        this.state.leaveRequestDates?.includes(dateString);
                      const holiday = this.state.Holidays.find(
                        (holiday) => holiday.Date === dateString,
                      );
                      const isSunday = date.getDay() === 0;
                      const isWorkingDay = !holiday && !isSunday;
                      const isUnmarkedWorkingDay =
                        isWorkingDay &&
                        !isAttendance &&
                        !isLeave &&
                        !isRegularized &&
                        !isLeaveRequest &&
                        !isCompOff &&
                        !isAbsent;
                      let tooltipText = null;

                      if (isLeave) {
                        tooltipText = "Leave";
                      } else if (holiday) {
                        tooltipText = holiday.Festival;
                      } else if (isLateAttendance) {
                        tooltipText = "Late Attendance";
                      } else if (isAttendance) {
                        tooltipText = "Attendance";
                      } else if (isRegularized) {
                        tooltipText = "Regularized";
                      } else if (isCompOff) {
                        tooltipText = "Comp Off";
                      } else if (isLeaveRequest) {
                        tooltipText = "Leave";
                      } else if (isAbsent) {
                        tooltipText = "Absent";
                      } else if (isUnmarkedWorkingDay) {
                        tooltipText = "Not Marked";
                      }

                      if (tooltipText) {
                        return (
                          <OverlayTrigger
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                          >
                            <span className="d-inline-block holiday-tooltip">
                              {day}
                            </span>
                          </OverlayTrigger>
                        );
                      } else {
                        return <span className="d-inline-block">{day}</span>;
                      }
                    }
                  }}
                />
              )}
            </Col>
            <Col className="col-md-8">
              {this.state.selectedEmployee && (
                <Row>
                  <Col>
                    <div className="overview-section">
                      <Row className="mb-3">
                        {/* <Col md="3">
                          <div className="date-selectors">
                            <select
                              value={`${this.state.currentYear}-${this.state.currentMonth}`}
                              onChange={this.handleMonthYearChange}
                              className="form-select border_radius"
                            >
                              {this.state.months.map((month) => (
                                <option key={month.value} value={month.value}>
                                  {month.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col> */}
                        <Col lg="7" md="7">
                          <h2>
                            Days Overview for {this.state.currentMonth}/
                            {this.state.currentYear}
                          </h2>
                        </Col>
                      </Row>
                      <Row className="text-center overviewSection">
                        <div className="col-md-3 overviewCol">
                          <strong>Total Days</strong>
                          <div className="alert alert-primary" role="alert">
                            {this.state.totalDaysInMonth}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Total Working Days</strong>
                          <div className="alert alert-secondary" role="alert">
                            {this.state.totalWorkingDays}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Present Days</strong>
                          <div className="alert alert-success" role="alert">
                            {this.state.presentDays}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Not Marked Days</strong>
                          <div className="alert alert-danger" role="alert">
                            {this.state.absentDays}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Regularize Request</strong>
                          <div className="alert alert-warning" role="alert">
                            {this.state.regularizedDays}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Late Attendance</strong>
                          <div className="alert alert-info" role="alert">
                            {this.state.lateDays}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Leave Balance</strong>
                          <div
                            className="alert employee-leave-balance"
                            role="alert"
                          >
                            {this.state.LeaveBalance}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Leave Taken</strong>
                          <div
                            className="alert employee-leave-taken"
                            role="alert"
                          >
                            {this.state.totalLeavesTaken}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Holidays This Month</strong>
                          <div className="alert employee-holidays" role="alert">
                            {this.state.holidays}
                          </div>
                        </div>
                        <div className="col-md-3 overviewCol">
                          <strong>Loss of Pay</strong>
                          <div
                            className="alert employee-lopleaves"
                            role="alert"
                          >
                            {this.state.lopleaves}
                          </div>
                        </div>
                      </Row>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
          <br />
        </div>
        {this.state.selectedEmployee && (
          <div className="mt-2">
            <Row>
              <Col lg="3">
                <Accordion defaultActiveKey="0">
                  {groupedData
                    .filter(
                      (yearData) =>
                        parseInt(yearData.year, 10) === this.state.currentYear,
                    )
                    .flatMap((yearData) =>
                      yearData.months.filter(
                        (monthData) =>
                          monthData.month === this.state.currentMonth,
                      ),
                    )
                    .map((monthData, index) => (
                      <Accordion.Item
                        eventKey={`${this.state.currentYear}-${monthData.month}`}
                        key={`${this.state.currentYear}-${monthData.month}`}
                      >
                        <Accordion.Header>
                          {`${new Date(0, monthData.month - 1).toLocaleString(
                            "default",
                            {
                              month: "long",
                            },
                          )} ${this.state.currentYear}`}
                        </Accordion.Header>
                        <Accordion.Body>
                          {monthData.data.length > 0 ? (
                            monthData.data.map((attendance, index) => (
                              <div key={index}>
                                <p>{this.formatDate(attendance)}</p>
                              </div>
                            ))
                          ) : (
                            <p>No attendance for this month.</p>
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                </Accordion>
              </Col>
            </Row>
          </div>
        )}
      </Container>
    );
  }
}
